export default "__VITE_ASSET__CvxLUxzN__"